import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TrueGrit} from "../../TrueGrit";

/**
 * Created by Jerker Nord on 2021-07-08.
 */

export class TrueGritReelStopAnimationRunner implements SimplePresentation {

    /**
     * This is just a way to pause the gameflow until all the reel stop animations have been completed
     */

    private static _controller:SimplePresentationRunnerController;
    private static _reelStopAnimationsPlaying:number = 0;
    private static _reelStopAnimationsStopped:number = 0;
    private static _hasStarted:boolean = false;

    shouldRun():boolean {
        TrueGritReelStopAnimationRunner._hasStarted = true;
        return true;
    }

    start(controller:SimplePresentationRunnerController):void {
        controller.setSkipCallback(() => this.skip());
        TrueGritReelStopAnimationRunner._controller = controller;
        //Only check for complete if no new scatters or grit girls has landed
        if((TrueGrit.model.numberOfScattersOnReels == TrueGrit.model.numberOfScattersBefore) && (TrueGrit.model.numberOfGritGirlsOnReels == TrueGrit.model.numberOfGritGirlsBefore)) {
            TrueGritReelStopAnimationRunner.checkAllAnimationsComplete();
        }
        //Animation has stopped before all reels, check if completed
        if(TrueGritReelStopAnimationRunner._reelStopAnimationsStopped > 0) {
            TrueGritReelStopAnimationRunner.checkAllAnimationsComplete();
        }
    }

    private skip():void {
        TrueGrit.symbolBoxView.aborted = true;
    }

    public static reelStopAnimationStarted():void {
        TrueGritReelStopAnimationRunner._reelStopAnimationsPlaying++;
    }

    public static reelStopAnimationStopped():void {
        TrueGritReelStopAnimationRunner._reelStopAnimationsStopped++;
        //If a Scatter finished playing before all reels stopped and this runner started
        if(TrueGritReelStopAnimationRunner._hasStarted == true) {
            TrueGritReelStopAnimationRunner.checkAllAnimationsComplete()
        }
    }

    private static checkAllAnimationsComplete():void {
        if(TrueGritReelStopAnimationRunner._reelStopAnimationsPlaying == TrueGritReelStopAnimationRunner._reelStopAnimationsStopped) {
            TrueGritReelStopAnimationRunner._reelStopAnimationsPlaying = 0;
            TrueGritReelStopAnimationRunner._reelStopAnimationsStopped = 0;
            TrueGritReelStopAnimationRunner._hasStarted = false;
            TrueGritReelStopAnimationRunner._controller.finish();
            TrueGrit.waysView.updateNumberOfWays();
        }
    }
}